import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChevronLeftIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15.798 8.298L11.574 12.5L15.798 16.702L14.5 18L9 12.5L14.5 7L15.798 8.298Z'
                fill='currentColor'
            />
        </>
    ),
})

ChevronLeftIcon.displayName = 'ChevronLeftIcon'
